module.exports = __webpack_public_path__ + "amcharts/images/lens_old.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/lens_old.png
// module id = 275
// module chunks = 0